import * as React from 'react';
import ErrorPage from '../ErrorPage/ErrorPage';
import Header from '../Header/Header';
import HeaderLogo from '../HeaderLogo/HeaderLogo';
import SettingsAndAccountWidget from '../SettingsAndAccountWidget/SettingsAndAccountWidget';
import DashboardButtonContainer from '../DashboardButton/DashboardButtonContainer';

export default (props: ClientSideErrorProps) => {
   const headerLeft = props.showHeaderButtons && <DashboardButtonContainer/>;
   const headerMiddle = <HeaderLogo linkToRoot={props.showHeaderButtons}/>;
   const headerRight = <SettingsAndAccountWidget/>;
   const headerSection = <Header leftSection={headerLeft} middleSection={headerMiddle} rightSection={headerRight}/>;

   return (
      <ErrorPage headerSection={headerSection} {...props}/>
   );
};

interface ClientSideErrorProps {
   title: string;
   text1: string;
   statusCode: number;
   showHeaderButtons: boolean;
   versionNotFound?: boolean;
}